import { createAction } from 'redux-act';

import Contact from '../../../models/interfaces/Contact';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchContactPayload extends FetchPayload {
  placeUuid: string;
}
export const fetchContact = createAction<FetchContactPayload>('FETCH_CONTACT');

export interface ContactFetchedPayload extends TimestampPayload {
  contact: Contact;
}
export const contactFetched = createAction<ContactFetchedPayload>('CONTACT_FETCHED');

export interface ContactFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const contactFetchFailed = createAction<ContactFetchFailedPayload>('CONTACT_FETCH_FAILED');

export type ContactFetchResponsePayload = ContactFetchedPayload | ContactFetchFailedPayload;
